var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Welcome'),_c('WelcomeFeatures'),_c('Servers',{attrs:{"preview":true}}),_c('WelcomeSoftware'),_c('TextSection',{attrs:{"mode":"light","message_id":"server_features","image_name":"serverfeatures.jpg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }